module.exports = __webpack_public_path__ + "static/media/banner_help.d03bb80c.png";